import Reflux from 'reflux';
import BuilderActions from '../action/builderActions';

export default Reflux.createStore({
  listenables: BuilderActions,
  onPublishSettingsData: function (settings) {
    this.trigger(settings);
  },
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/builder/store/settingStore.js
 **/